exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1[data-v-f711e378],h2[data-v-f711e378]{font-weight:400}ul[data-v-f711e378]{list-style-type:none;padding:0}li[data-v-f711e378]{display:inline-block;margin:0 10px}a[data-v-f711e378]{color:#42b983}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f711e378","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/lib/test.vue
// module id = 4
// module chunks = 0